import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { axInst, axInstBasic } from "../Service/Service";
import Loader from "../../components/Loader/Loader";
import Swal from "sweetalert2";

function Login() {
  const navigate = useNavigate();
  const { keycloak, initialized } = useKeycloak();
  const [loading, setLoading] = useState(false);

  // Capture params ONCE — only if directly coming from iframe
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const parArn = urlParams.get("parArn");
    const isDealer = urlParams.get("isDealer");

    if (parArn) localStorage.setItem("parArn", parArn);
    if (isDealer !== null) localStorage.setItem("isDealer", isDealer);
  }, []);

  const handleLogin = useCallback(
    async (token, username) => {
      setLoading(true);


      try {
        let res;
        const iframeRedirect = localStorage.getItem("iframe_redirect");

        if (iframeRedirect === "piplineAndService") {
          res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}loginDealer`,
            { token }
          );

          if (res.data.message === "Successful") {
            localStorage.setItem("token", res.data.token.accessToken);
            localStorage.setItem("username", username);

            await axInst.post(`${process.env.REACT_APP_API_URL}userSyslogs`, {
              portal_name: "Dealer360"
            });

            localStorage.removeItem("iframe_redirect");
            navigate("/piplineAndService");
          } else {
            await Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "User Does Not Exist",
            });

            await keycloak.logout({
              redirectUri: window.location.origin + "/",
            });
          }
        } else {
          res = await axInstBasic.post(
            `${process.env.REACT_APP_API_URL}login`,
            { token }
          );

          localStorage.setItem("token", res.data.token.accessToken);
          localStorage.setItem("username", username);
          localStorage.setItem("pos_type", res.data.pos_type);

          if (res.data.message === "Login successful") {
            await axInst.post(`${process.env.REACT_APP_API_URL}userSyslogs`, {
              portal_name: "Customer360"
            });

            navigate("/landing");
          } else {
            await Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "User Does Not Exist",
            });

            await keycloak.logout({
              redirectUri: window.location.origin + "/",
            });

            localStorage.clear();
          }
        }
      } catch (error) {
        console.error("Login error:", error);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong. Please try again.",
        });
      } finally {
        setLoading(false);
      }
    },
    [navigate, keycloak]
  );

  useEffect(() => {
    if (!initialized) return;

    if (!keycloak.authenticated) {
      keycloak.login();
      return;
    }

    const username = keycloak.tokenParsed?.preferred_username;
    const token = keycloak.token;

    handleLogin(token, username);
  }, [initialized, keycloak, handleLogin]);

  return (
    <div className="flex items-center justify-center h-screen">
      {loading ? <Loader /> : <p className="text-lg">Redirecting...</p>}
    </div>
  );
}

export default Login;